import { __decorate, __extends } from "tslib";
import Vue from "vue";
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import BrowserHelper from "../helper/browser-helper";
var Selextbox = /** @class */ (function (_super) {
    __extends(Selextbox, _super);
    function Selextbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentValue = '';
        return _this;
    }
    Selextbox.prototype.mounted = function () {
        this.currentValue = this.defaultItem;
    };
    Object.defineProperty(Selextbox.prototype, "itemsFromJson", {
        get: function () {
            var options = this.items != '' ? JSON.parse(this.items.replace(/'/g, '"')) : [];
            if (BrowserHelper.isAppleDevice()) {
                options.splice(0, 0, '');
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Selextbox.prototype.focusChanged = function (focus) {
        return focus;
    };
    Selextbox.prototype.inputValueChanged = function (value) {
        return typeof value == "undefined" ? '' : value;
    };
    Selextbox.prototype.defaultItemChanged = function (newValue) {
        this.currentValue = newValue;
    };
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "inputName", void 0);
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "items", void 0);
    __decorate([
        Prop({ default: false })
    ], Selextbox.prototype, "itemsHaveGroups", void 0);
    __decorate([
        Prop({ default: function () { return new Map(); } })
    ], Selextbox.prototype, "groupItems", void 0);
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "label", void 0);
    __decorate([
        Prop({ default: false })
    ], Selextbox.prototype, "fullWidth", void 0);
    __decorate([
        Prop({ default: false })
    ], Selextbox.prototype, "labelHidden", void 0);
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "selectModifier", void 0);
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "inputId", void 0);
    __decorate([
        Prop({ default: false })
    ], Selextbox.prototype, "small", void 0);
    __decorate([
        Prop({ default: '' })
    ], Selextbox.prototype, "defaultItem", void 0);
    __decorate([
        Emit('focuschanged')
    ], Selextbox.prototype, "focusChanged", null);
    __decorate([
        Emit('inputValueChanged')
    ], Selextbox.prototype, "inputValueChanged", null);
    __decorate([
        Watch('defaultItem')
    ], Selextbox.prototype, "defaultItemChanged", null);
    Selextbox = __decorate([
        Component
    ], Selextbox);
    return Selextbox;
}(Vue));
export default Selextbox;
